import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthenticateDomainService {

    constructor(private api: ApiService) { }

    authenticateClientDomain(data: any): Observable<any> {
        return this.api.post(environment.authenticateClientDomain, data);
    }

    setDefaultDomain(data: any): Observable<any> {
        return this.api.post(environment.updateClientDomain, data);
    }

    domainVeriicationStatus(data: any): Observable<any> {
        return this.api.post(environment.domainVeriicationStatus, data);
    }

    verifyDomainEmail(data: any): Observable<any> {
        return this.api.post(environment.verifyDomainEmail, data);
    }

    getAllClientDomain(data: any): Observable<any> {
        return this.api.post(environment.getAllClientDomain, data);
    }

    deleteDomainAndEmail(data: any): Observable<any> {
        return this.api.post(environment.deleteDomainAndEmail, data);
    }
}
